import app from '../../config/configApp';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

app.component('font-awesome-icon', FontAwesomeIcon);
